import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/signing-requests/$requestId')({
  staticData: {
    hideShell: true,
    breadcrumb: 'Signing Request Detail',
    breadcrumbKey: 'K_BREADCRUMB_SIGNING_REQUEST_DETAIL',
  },
});
